export enum MicrodataTypeEnum {
  // All Json+Ld types must be declared here
  Event = 'event',
  Breadcrumb = 'breadcrumb',
}
